/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/require-default-props */
import '@fullcalendar/core/vdom';

import React from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction';
import ptLocale from '@fullcalendar/core/locales/pt-br';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import moment from 'moment';
import companyId from 'services/company_id';
import { ProfileState } from 'store/modules/profile_store/types';
import { Container } from './styles';

interface EventType {
  id: string;
  title: string;
  start: Date;
  className: string;
  description: string;
  type: string;
  bidding_id?: number;
  display?: string;
}
interface CalendarProps {
  eventsList: Array<EventType>;
  setSelectedTaskId?: React.Dispatch<React.SetStateAction<number>> | null;
  onDatesSet?: (range: { start: Date; end: Date }) => void;
  onTaskClick?: (eventId: string, biddingId?: number) => void;
}
const Calendar = (props: CalendarProps) => {
  const { eventsList, setSelectedTaskId = null, onDatesSet, onTaskClick } = props;

  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const eventRender = (info: any) => {
    const tooltip = info.event.extendedProps.description;
    if (info.view.type === 'listDay') {
      return <>{info.event.extendedProps.description}</>;
    }

    return (
      <div className="databalloon" data-balloon-length="large" aria-label={`${tooltip}`}>
        {`${moment(info.event.start).format('HH:mm')} ${info.event.title}`}
      </div>
    );
  };

  return (
    <Container className="col-md-12 p-0">
      <div className="card rounded p-3 shadow w-100">
        <FullCalendar
          initialView="dayGridMonth"
          headerToolbar={{
            left: 'prev,next today',
            center: 'title',
            right: 'dayGridMonth,listDay,dayGridWeek',
          }}
          buttonText={{
            listDay: 'Agenda do dia',
            dayGridWeek: 'Agenda da semana',
          }}
          plugins={[dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin]}
          locales={[ptLocale]}
          locale="pt-br"
          dayMaxEvents={3}
          events={eventsList}
          eventTimeFormat={{
            hour: '2-digit',
            minute: '2-digit',
            meridiem: false,
            hour12: false,
          }}
          eventContent={eventRender}
          eventClick={(info) => {
            const eventType = info.event.extendedProps.type;
            const biddingIdFromEvent = info.event.extendedProps.bidding_id;
            if (eventType === 'bidding' || eventType === 'progress') {
              const targetId = biddingIdFromEvent || info.event.id;
              window.open(
                `/minhas_licitacoes/management/${targetId}/${companyId(profile)}`,
                'management',
              );
              return;
            }
            if (eventType === 'task') {
              if (onTaskClick) {
                onTaskClick(info.event.id, biddingIdFromEvent);
                return;
              }
              if (setSelectedTaskId) {
                const taskId = Number(String(info.event.id).replace(/^t-/, ''));
                if (taskId) {
                  setSelectedTaskId(taskId);
                  return;
                }
              }
              if (biddingIdFromEvent) {
                window.open(
                  `/minhas_licitacoes/management/${biddingIdFromEvent}/${companyId(profile)}`,
                  'management',
                );
              }
            }
          }}
          datesSet={(arg) => {
            if (onDatesSet) onDatesSet({ start: arg.start, end: arg.end });
          }}
          themeSystem="bootstrap4"
        />
      </div>
    </Container>
  );
};

export default Calendar;
